/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Exporting_ButtonInputs */

const en_batch_subtitle_export_exporting_button = /** @type {(inputs: Batch_Subtitle_Export_Exporting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporting...`)
};

const fr_batch_subtitle_export_exporting_button = /** @type {(inputs: Batch_Subtitle_Export_Exporting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation...`)
};

const de_batch_subtitle_export_exporting_button = /** @type {(inputs: Batch_Subtitle_Export_Exporting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportieren...`)
};

const it_batch_subtitle_export_exporting_button = /** @type {(inputs: Batch_Subtitle_Export_Exporting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione in corso...`)
};

const ru_batch_subtitle_export_exporting_button = /** @type {(inputs: Batch_Subtitle_Export_Exporting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт...`)
};

const es_batch_subtitle_export_exporting_button = /** @type {(inputs: Batch_Subtitle_Export_Exporting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportador...`)
};

const zh_cn2_batch_subtitle_export_exporting_button = /** @type {(inputs: Batch_Subtitle_Export_Exporting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口...`)
};

const ja_batch_subtitle_export_exporting_button = /** @type {(inputs: Batch_Subtitle_Export_Exporting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポート中...`)
};

const hi_batch_subtitle_export_exporting_button = /** @type {(inputs: Batch_Subtitle_Export_Exporting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात हो रहा है...`)
};

const pt_pt2_batch_subtitle_export_exporting_button = /** @type {(inputs: Batch_Subtitle_Export_Exporting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportador...`)
};

/**
* | output |
* | --- |
* | "Exporting..." |
*
* @param {Batch_Subtitle_Export_Exporting_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_exporting_button = /** @type {((inputs?: Batch_Subtitle_Export_Exporting_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Exporting_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_exporting_button(inputs)
	if (locale === "de") return de_batch_subtitle_export_exporting_button(inputs)
	if (locale === "it") return it_batch_subtitle_export_exporting_button(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_exporting_button(inputs)
	if (locale === "es") return es_batch_subtitle_export_exporting_button(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_exporting_button(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_exporting_button(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_exporting_button(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_exporting_button(inputs)
	return en_batch_subtitle_export_exporting_button(inputs)
});